module.exports = __webpack_public_path__ + "media/new-message.f5fc4464.mp3";